export function safeHtmlDecode(input?: string | null) {
  if (!input) return null
  const doc = new DOMParser().parseFromString(input, "text/html")
  return doc.documentElement.textContent
}
